import { i18n_config_default } from './chunk-5FPUWZMY.mjs';

// src/helpers/factories/menuCategoryCardFactory.ts
var menuCategoryCardFactory = (categories) => Object.values(categories).map((category) => {
  const subcategoriesCount = category.subcategoryIds.length;
  const elementsCount = category.itemIds.length + category.comboIds.length;
  return {
    id: category.categoryId,
    title: category.name,
    menuTypeIds: category.menuTypeIds,
    itemCount: elementsCount + subcategoriesCount,
    customTag: `${i18n_config_default.t("components.menuCard.tag.subcategoryCountShort", {
      count: subcategoriesCount
    })} | ${i18n_config_default.t("components.menuCard.tag.elementCount", {
      count: elementsCount
    })}`,
    status: category.active,
    activeFilter: category.active ? 1 : 2
  };
});
var dropdownFilteredCategoryOptionFactory = (categories) => Object.values(categories).filter((category) => {
  return Object.keys(category.subcategoryMenuTypeItemsIds || {}).length > 0;
}).map((category) => ({
  label: category.name,
  value: category.categoryId
}));
var dropdownAllCategoryOptionFactory = (categories) => Object.values(categories).map((category) => ({
  label: category.name,
  value: category.categoryId,
  inActive: !category.active
}));

export { dropdownAllCategoryOptionFactory, dropdownFilteredCategoryOptionFactory, menuCategoryCardFactory };
